import React from 'react';

export const DumpertSingleDLogoIcon = (props) => {
  return (
    <svg viewBox='0 0 72.4 72.4' fill='currentColor' {...props}>
      <g>
        <path
          d='M39.6,0H0v70.8h35.3C60,70.8,71.5,57,71.5,35.3C71.5,17.4,63.2,0,39.6,0z M20.6,54.9V16.5L54,35.7
		L20.6,54.9z'
        />
      </g>
    </svg>
  );
};
